<template>
  <div id="top-people">
    <div class="">
      <slot name="chosen-card"></slot>
      <v-layout row wrap align-center justify-center fill-height mx-5
                v-for="(athletesByCat,athleteKey) in athletesByCategory" :key="athleteKey"
                v-if="athletesByCategory && athleteInfoTextById">
        <v-flex xs12 v-if="athletesByCat.length>0"><h2 class="elevation-2 white-bg pl-2 mt-2">{{athleteKey === 'noCat' ?
          'Weitere Sportler' : athleteKey}}</h2></v-flex>
        <v-flex xs4 lg2 order-lg2 v-for="(person,key) in athletesByCat" :key="key"
                @click="updateChosen(person)">
          <v-card class="ma-2 v-card--hover">
            <v-img :src="$helper.imgServerUrl() + person.img" aspect-ratio="1" :alt="'Profile picture from '+ person.firstName + ' ' + person.lastName"></v-img>
            <v-card-title>{{person.firstName}} {{person.lastName}}</v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: "people-athlete",
    computed: {
      ...mapGetters(['athleteInfoTextById']),
      athletesByCategory() {
        const map = {
          Meisterklasse: [],
          Junioren: [],
          Jugend: [],
          Nachwuchs: [],

          "Nachwuchs A": [],
          "Nachwuchs B": [],
          Neulinge: [],
          "Anfänger": [],
          Sternschnuppen: [],
          Erwachsene: [],
          noCat: []
        }
        // console.log(this.people)
        Array.prototype.forEach.call(this.people, athlete => {
          // console.log('type', typeof athlete)
          const categories = this.athleteInfoTextById[athlete.id] && this.athleteInfoTextById[athlete.id].category ?
            this.athleteInfoTextById[athlete.id].category.split(',') : []
          if (categories.length === 0 || categories.length === 1 && categories[0].length <= 1) {
            map.noCat.push(athlete)
          } else {
            categories.forEach(cat => {
              if (cat !== '-') {
                map[cat] && cat.length > 1 ? map[cat].push(athlete) : map[cat] = [athlete]
              }
            })
          }
        })
        // console.log(map)
        return map
      }
    },
    props: {
      people: {
        type: Array,
        required: true
      },
    },
    data() {
      return {
        cats: ['Meisterklasse', 'Junioren', 'Jugend', 'Nachwuchs', 'Neulinge', 'Anfänger', 'Sternschnuppen', 'Erwachsene', 'noCat']
      }
    },
    methods: {
      updateChosen(person) {
        this.$vuetify.goTo('#top-people', {offset: -100, duration: 300, easing: "easeOutCubic"})
        // console.log('new person', person, this.athleteInfoTextById[person.id])
        this.$emit('updateChosen', person)
      }
    },
  }
</script>

